import React, { useContext, useEffect, useState } from "react";
import ReactImageGallery from "react-image-gallery";
import { addItem } from "../../utils/addtocart";
import { addWishlist } from "../../utils/addtowishlist";
import axios from "axios";
import ApiLinkContext from "../../context/ApiLinkContext";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";
import { Toaster, toast } from "sonner";

import manicon from "../../assets/img/manicon.png";
import womanicon from "../../assets/img/womanicon.jpg";
import unisexicon from "../../assets/img/unisexicon.png";
import Swal from "sweetalert2";

const ModalReview = ({ data }) => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const { brand } = useContext(ApiLinkContext);
  const [inputs, setInputs] = useState({
    name: "",
    surname: "",
    messages: "",
    star: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStarClick = (starValue) => {
    setInputs((prev) => ({
      ...prev,
      star: starValue,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("https://myperfume.az/api/rev.php", {
        name: inputs.name,
        surname: inputs.surname,
        messages: inputs.messages,
        star: inputs.star,

        product_id: data && data?.id,
      })
      .then((res) => {
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: "Rəyiniz əlavə olundu",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          window.location.reload(); // səhifəni yeniləyir
        });
      })
      .catch((err) => {
        console.log(err);
      });
    // Burada form məlumatlarını göndərə bilərsən (API çağırışı və s.)
  };
  const imageArray =
  data && Array.isArray(data.img) && data.img.length > 0
    ? data.img.map((image) => ({
        original: image,
        thumbnail: image,
      }))
    : [];

   const findBrandName = brand.find((item)=>data && data?.brand == item.id)
  return (
    <div className="modal fade theme1 style1" id="quick-view1" role="dialog">
      <Toaster position="top-right" richColors />
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <h4 className="py-3 px-4">{t.review}</h4>
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="row justify-content-center g-2">
                <div className="col-5">
                {findBrandName && findBrandName.bName}  {data.name} {data.volume + " " + t.ml}
                <ReactImageGallery
                        items={imageArray}
                        showNav={false}
                        showPlayButton={false}
                        thumbnailPosition={"bottom"}
                        additionalClass="custom-gallery"
                      />
                </div>
              <div className="col-md-8  col-lg-7 mb-5 mb-lg-0 ">
                <div>
                  <div>
                    <div class="ratting-form-wrapper ">
                      <div
                        class="ratting-form p-3"
                        style={{ 
                        border: "1px solid #e6e6e6",
                        borderRadius:"10px"
                    }}
                      >
                        <form onSubmit={handleSubmit}>
                          <div className="rating-product">
                            <span>{t.mehsuluqiymetlendir}</span>
                            <br />
                            {[1, 2, 3, 4, 5].map((star) => (
                              <i
                                key={star}
                                className={`ion-android-star ${
                                  star <= inputs.star ? "active1" : ""
                                }`}
                                onClick={() => handleStarClick(star)}
                                style={{
                                  cursor: "pointer",
                                  color:
                                    star <= inputs.star ? "orange" : "gray",
                                  fontSize: "25px",
                                }}
                              ></i>
                            ))}
                            {inputs.star && (
                              <span className="mx-2">
                                ({inputs.star}) {t.star}
                              </span>
                            )}
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="rating-form-style mb-10">
                                <input
                                  placeholder={t.firstName}
                                  type="text"
                                  name="name"
                                  required
                                  value={inputs.name}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="rating-form-style mb-10">
                                <input
                                  placeholder={t.lastName}
                                  type="text"
                                  name="surname"
                                  value={inputs.surname}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="rating-form-style form-submit">
                                <textarea
                                  name="messages"
                                  required
                                  placeholder={t.mesajiniz}
                                  value={inputs.messages}
                                  onChange={handleChange}
                                ></textarea>
                                <div className="d-flex justify-content-center align-items-center">
                                  <input type="submit" value={t.gonder} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalReview;
